export default function NotificationPanel({ isOpen, notifications, markAsRead, markAllAsRead }) {
    if (!isOpen) return null;

    return (
        <div className="absolute right-[114px] top-[37px] mt-2 w-96 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
            <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
                <h3 className="text-lg font-semibold text-gray-900">Notifications</h3>
                <button onClick={markAllAsRead} className="text-sm text-blue-600 hover:text-blue-800 font-medium">
                    Mark all as read
                </button>
            </div>

            <div className="px-4 py-2">
                <span className="text-sm font-medium text-gray-600">New</span>
            </div>

            <div className="max-h-96 overflow-y-auto pl-[10px]">
                {notifications.map(n => (
                    <div key={n.id} className={`px-4 py-3 border-b border-gray-100 mt-[4px] rounded-[6px] hover:bg-gray-50 transition-colors ${!n.isRead ? 'bg-purple-50' : ''}`}>
                        <div className="flex items-start gap-3">
                            <div className="flex-shrink-0">
                                <div className="w-10 h-10 rounded-full bg-gray-300 flex items-center justify-center">
                                    <svg className="w-6 h-6 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                                    </svg>
                                </div>
                            </div>
                            <div className="flex-1 min-w-0">
                                <p className="text-sm font-semibold text-gray-900 mb-1">{n.user}</p>
                                <p className="text-sm text-gray-700 mb-1">{n.message}</p>
                                <p className="text-xs text-gray-500 mb-2">{n.time}</p>
                                {!n.isRead && (
                                    <button onClick={() => markAsRead(n.id)} className="text-xs text-blue-600 hover:text-blue-800 font-medium">
                                        Mark as read
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
